export default "__VITE_ASSET__5m7nJSD0__"